module.exports = __webpack_public_path__ + "media/images/official/special_migration_03-b03c92b92d5bc09f3c30ad06daa924b2.jpg";